import { ReactComponent as ErrorIcon } from 'assets/images/errorIcon.svg';
import { Controller, Control, useFormState } from 'react-hook-form';
import { ReactSelectFlora, ReactSelectFloraProps } from './ReactSelectFlora';
import { Wrapper } from './styles';

interface ReactSelectFloraControllerProps extends ReactSelectFloraProps {
  name: string;
  control: Control;
  disabled?: boolean;
}

export const ReactSelectFloraController = ({
  options,
  label,
  control,
  name,
  id,
  required = false,
  disabled = false,
}: ReactSelectFloraControllerProps): JSX.Element => {
  const { errors } = useFormState({
    control,
  });

  const inputError = errors[name]?.message;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field: { onChange, value } }) => (
        <Wrapper>
          <ReactSelectFlora
            label={label}
            required={required}
            id={id}
            options={options}
            hasError={!!inputError}
            value={options.find((c: any) => c.value === value.value)}
            onChangeSelect={(val: any) => onChange(val)}
            disabled={disabled}
          />
          {!!inputError && (
            <span className="select-error">
              <ErrorIcon />
              {inputError?.toString()}
            </span>
          )}
        </Wrapper>
      )}
    />
  );
};
